//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SanityBlockContent from '~/components/sanity/SanityBlockContent.vue';
export default {
  components: {
    SanityBlockContent
  },
  props: {
    columns: {
      type: Array
    },
    styles: {
      type: Object
    },
    mobileStyles: {
      type: Object
    }
  },

  data() {
    return {
      isMobile: false
    };
  },

  mounted() {
    this.isMobile = window.innerWidth <= 819;
  }

};